function fn_part_sidebar() {
    $part = $(".part_sidebar");
    $part.find("[data-sidebar-title]").on("click",function(e){
        e.preventDefault();
        $(this).toggleClass("active").next(".nav_ul").children("ul").toggleClass("active").slideToggle(500);
    });
    setTimeout(function(){
        if ($(window).width() > 960) {
            if ($part.find("[data-sidebar-title]").next(".nav_ul").children("ul").find("a").hasClass("active")) {
                $part.find("[data-sidebar-title]").next(".nav_ul").children("ul").find("a.active").parents("ul").addClass("active").slideDown(500).parent(".nav_ul").prev("[data-sidebar-title]").addClass("active");
            } else {
                $part.find("[data-sidebar-title]:first-child").trigger("click");
            }
        }
    }, 200);
}